export function findDuplicateRecords(parsedData, uniqueKeys = []) {
    const seen = new Map();
    const errors = [];

    parsedData.forEach((item, index) => {
        let signature, valueForOutput;

        if (uniqueKeys.length > 0) {
            signature = uniqueKeys.map(k => `${k}:${item[k] ?? "undefined"}`).join("|");
            valueForOutput = uniqueKeys.reduce((acc, k) => {
                acc[k] = item[k] ?? "undefined";
                return acc;
            }, {});
        } else {
            const normalized = Object.keys(item)
                .sort()
                .reduce((acc, key) => {
                    acc[key] = item[key];
                    return acc;
                }, {});
            signature = JSON.stringify(normalized);
            valueForOutput = normalized;
        }

        if (!seen.has(signature)) {
            seen.set(signature, { value: valueForOutput, indices: [] });
        }
        seen.get(signature).indices.push(index + 1);
    });

    for (const { value, indices } of seen.values()) {
        if (indices.length > 1) {
            indices.forEach(row => {
                const field = uniqueKeys.length > 0 ? uniqueKeys.join(", ") : null;
                let message;
                if (uniqueKeys.length > 0) {
                    const valuesOnly = uniqueKeys.map(k => value[k]).join(", ");
                    message = `Duplicate value(s): ${valuesOnly}`;
                } else {
                    message = `Duplicate row`;
                }

                errors.push({
                    field,
                    row: row + 1,
                    message
                });
            });

        }
    }
    return errors;
}